import { FC, HTMLAttributes } from 'react';

import { Calendar, Flex } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';

import { EFilters, useFilters } from 'features/Filters';
import { PlannerPost, PlannerPostResponse, PlannerPosts, usePlannerDates } from 'features/Planner';
import { formatDate } from 'shared/utils';

import 'dayjs/locale/ru';

import styles from './PlannerMonth.module.scss';
dayjs.locale('ru');

interface IPlannerMonthProps extends HTMLAttributes<HTMLDivElement> {
	posts: PlannerPostResponse;
}

export const PlannerMonth: FC<IPlannerMonthProps> = ({ className, posts, ...props }) => {
	const { onMultiFiltersChange } = useFilters();

	const { date } = usePlannerDates();

	const postsMap = posts.results.reduce(
		(acc, post) => {
			const date = formatDate(new Date(post.published_at), 'iso') || '';
			acc[date] = [...(acc[date] || []), post];
			return acc;
		},
		{} as Record<string, PlannerPost[]>,
	);

	return (
		<div {...props} className={cn(styles.wrapper, className)}>
			<Calendar
				style={{ minWidth: 760 }}
				value={dayjs(date)}
				headerRender={() => null}
				onSelect={(value) => {
					onMultiFiltersChange(
						[EFilters.PLANNER_TYPE, EFilters.PLANNER_DATE],
						['day', formatDate(value.toDate(), 'iso')],
					);
				}}
				fullCellRender={(date) => {
					const isToday = date.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');

					return (
						<div className={styles.dayWrapper}>
							<Flex vertical align="end" className={cn(styles.day, { [styles.today]: isToday })}>
								{date.format('DD')}
								{postsMap[date.format('YYYY-MM-DD')]?.length > 0 && (
									<PlannerPosts posts={postsMap[date.format('YYYY-MM-DD')]} />
								)}
							</Flex>
						</div>
					);
				}}
			/>
		</div>
	);
};

export default PlannerMonth;
